import {NoteDataModel} from '../../../../models/notes/note-data.model';

export class TdoNoteSaveModel {
  typeEnumIds: string[] = [];
  categoryEnumIds: string[] = [];
  text: string = '';
  patientId: string;
  associatedObjects: TdoNoteAssociatedObject[] = [];
  dataNote: NoteDataModel;

  constructor(dataNote: NoteDataModel = null) {
    if (dataNote) {
      this.dataNote = dataNote;
    }
  }
}

export class TdoNoteAssociatedObject {
  parentObjectName: string;
  objectId: string;
}
